// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseImageBlock_wrapper__DGpfw","pointer":"BaseImageBlock_pointer__xW7CG"};